module.exports = __webpack_public_path__ + "img/frame (190).7f42b642.jpg";